/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Toast_Upload_ErrorInputs */

const en_toast_upload_error = /** @type {(inputs: Toast_Upload_ErrorInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`There was an error uploading your file`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`There was an error uploading your files`);
	return /** @type {LocalizedString} */ ("toast_upload_error");
};

const es_toast_upload_error = /** @type {(inputs: Toast_Upload_ErrorInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("es", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`Hubo un error al subir tu archivo`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`Hubo un error al subir tus archivos`);
	return /** @type {LocalizedString} */ ("toast_upload_error");
};

/**
* | countPlural | output |
* | --- | --- |
* | "one" | "There was an error uploading your file" |
* | "other" | "There was an error uploading your files" |
*
* @param {Toast_Upload_ErrorInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const toast_upload_error = /** @type {((inputs: Toast_Upload_ErrorInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Upload_ErrorInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_toast_upload_error(inputs)
	return en_toast_upload_error(inputs)
});